import { Injectable } from '@angular/core';
import { DataService } from '../../architecture/data.service';
import { Result } from '../../architecture/envelopes';
import { Email } from '../../models/email.model';
import { AuthorizationEmail } from '../../models/authorizationEmail.model';
import { AuthorizationEmailOption } from '../../models/authorizationEmailOption.model';

@Injectable({ providedIn: 'root' })
export class EmailService {
    constructor(private dataService: DataService) { }

    public getByDealer(dealerCod: string) {
        return this.dataService.get<Result<Email[]>>('email/dealer/' + dealerCod);
    }

    public getAuthorizationEmail() {
        return this.dataService.get<Result<AuthorizationEmail[]>>('email/authorization');
    }

    public deleteAuthorizationEmail(id: string) {
        return this.dataService.delete<Result>('email/authorization/' + id);
    }

    public updateBusOption(id: string, value: string) {
        let option = new AuthorizationEmailOption();
        option.id = id;
        option.value = value;

        return this.dataService.post<Result>('email/authorization/busoption', option);
    }

    public updateTruckOption(id: string, value: string) {
        let option = new AuthorizationEmailOption();
        option.id = id;
        option.value = value;

        return this.dataService.post<Result>('email/authorization/truckoption', option);
    }

    public insertAuthorizationEmail(email: AuthorizationEmail) {
        return this.dataService.post<Result<AuthorizationEmail>>('email/authorization', email);
    }

    public delete(cod: number) {
        return this.dataService.delete<Result<string>>('email/' + cod.toString());
    }

    public insert(email: Email) {
        return this.dataService.post<Result<Email>>('email', email);
    }
}
